import React, { useEffect, useRef } from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const { FiMapPin, FiSearch } = FiIcons;

const AddressInput = ({ onAddressSelected, disabled = false, placeholder = "Start typing your street address..." }) => {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);

  useEffect(() => {
    // Don't initialize if the Google Maps API isn't loaded
    if (!window.google || !window.google.maps || !window.google.maps.places) {
      console.error("Google Maps Places API not available in AddressInput component");
      return;
    }

    try {
      // Initialize Google Places Autocomplete with US restriction
      const options = {
        componentRestrictions: { country: ["us"] },
        fields: ["place_id", "formatted_address", "address_components", "geometry"]
      };
      
      autocompleteRef.current = new window.google.maps.places.Autocomplete(
        inputRef.current,
        options
      );

      // Add listener for place selection
      const listener = autocompleteRef.current.addListener('place_changed', () => {
        const place = autocompleteRef.current.getPlace();
        
        // Ensure we have a valid place with a place_id
        if (!place || !place.place_id) {
          console.error("Invalid place selected:", place);
          return;
        }
        
        // Pass the full place object to the parent component
        onAddressSelected(place);
      });

      // Clean up listener on unmount
      return () => {
        if (window.google && window.google.maps && listener) {
          window.google.maps.event.removeListener(listener);
        }
      };
    } catch (error) {
      console.error("Error initializing Google Places Autocomplete:", error);
    }
  }, [onAddressSelected]);

  return (
    <div className="relative">
      <SafeIcon icon={FiMapPin} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
      <input
        ref={inputRef}
        type="text"
        disabled={disabled}
        placeholder={placeholder}
        className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-patriot-red focus:border-transparent"
        autoComplete="off"
      />
    </div>
  );
};

export default AddressInput;